import z from "zod";

export const searchSchema = z.object({
  country: z.string().optional().catch(undefined),
  itemsPerPage: z.optional(z.number()).catch(25),
  name: z.string().optional().catch(undefined),
  order: z
    .optional(
      z.object({
        country: z.optional(z.enum(["asc", "desc"])).catch(undefined),
        fullvendorname: z.optional(z.enum(["asc", "desc"])).catch(undefined),
        sap_code: z.optional(z.enum(["asc", "desc"])).catch(undefined),
        segment: z.optional(z.enum(["asc", "desc"])).catch(undefined),
        segment2: z.optional(z.enum(["asc", "desc"])).catch(undefined),
        taxnumber1: z.optional(z.enum(["asc", "desc"])).catch(undefined),
      }),
    )
    .default({ fullvendorname: "asc" })
    .catch({ fullvendorname: "asc" }),
  page: z.optional(z.number()).catch(1),
  sapCode: z.string().optional().catch(undefined),
  segment: z.string().optional().catch(undefined),
  taxNumber: z.string().optional().catch(undefined),
});

export type OrderSearchSchema = z.infer<typeof searchSchema.shape.order>;
